import { ModifierFunction } from './base'

const rubberband = (() => {
}) as unknown as ModifierFunction<any, any, 'rubberband'>

rubberband._defaults = {}

export default rubberband
